import axios from '../../../utils/interceptor'
import { BASE_URL, GET_MEDIA, ADD_MEDIA, DELETE_MEDIA } from '../../../resources/APIEndpoints'

function MediaServices(){
    this.getMedia = (body) => axios.post(BASE_URL + GET_MEDIA, body)
    this.addMedia = (body,headers) => axios.post(BASE_URL + ADD_MEDIA, body,headers)
    this.deleteMedia = (body) => axios.post(BASE_URL + DELETE_MEDIA, body)
}

export default new MediaServices();